/**
 * RecordingIndicator — Visual pulse indicator shown during active recording.
 *
 * Displays a pulsing red dot, duration timer, and live interim transcript
 * to provide real-time feedback while recording is in progress.
 */

interface RecordingIndicatorProps {
  readonly durationSeconds: number;
  readonly interimTranscript: string;
}

export function RecordingIndicator({
  durationSeconds,
  interimTranscript,
}: RecordingIndicatorProps) {
  const minutes = Math.floor(durationSeconds / 60);
  const seconds = durationSeconds % 60;
  const timeDisplay = `${minutes}:${seconds.toString().padStart(2, "0")}`;

  return (
    <div className="fb-recording-indicator" aria-live="polite">
      <div className="fb-recording-dot-row">
        <span className="fb-recording-dot" aria-hidden="true" />
        <span className="fb-recording-time">{timeDisplay}</span>
        <span className="fb-recording-label">Recording&hellip;</span>
      </div>
      {interimTranscript && (
        <p className="fb-interim-transcript">{interimTranscript}</p>
      )}
    </div>
  );
}
